import { render } from "./CurriculumTable.vue?vue&type=template&id=5b4b0432&scoped=true"
import script from "./CurriculumTable.vue?vue&type=script&lang=js"
export * from "./CurriculumTable.vue?vue&type=script&lang=js"

import "./CurriculumTable.vue?vue&type=style&index=0&id=5b4b0432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4b0432"]])

export default __exports__